import {Event} from "@models";
import {CalendarSortOrder, CalendarSortValue} from "../calendar-sorting/calendar-sorting.component";

export class EventUtils {
	static getEventTime(event: Event): number {
		const raw = event.firstSessionStart ?? event.start;
		return raw ? new Date(raw).getTime() : 0;
	}

	static compareEvents(a: Event, b: Event, sortValue: CalendarSortValue, sortOrder: CalendarSortOrder): number {
		const direction = sortOrder === "asc" ? 1 : -1;

		if (sortValue === "name") {
			const nameCmp = a.name.localeCompare(b.name);
			if (nameCmp !== 0) {
				return nameCmp * direction;
			}
		}

		return (EventUtils.getEventTime(a) - EventUtils.getEventTime(b)) * direction;
	}
}
